import { createContext, useContext, type PropsWithChildren } from "react";
import { type MeResponse } from '@intone/shared';
import { useUser } from '../model/useUser';

const UserContext = createContext<MeResponse | undefined>(undefined);

export const useUserData = () => {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error('useUser must be used within a UserProvider');
	}
	return context;
};

type Props = PropsWithChildren & {
	orgId: string | null;
}

export function UserProvider({ children, orgId }: Props){
	const { data, isLoading, isSuccess } = useUser(orgId);

	if (isLoading || !isSuccess) {
		return null;
	}

	return (
		<UserContext.Provider value={data}>
			{children}
		</UserContext.Provider>
	);
}